import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VNavigationDrawer,
        {
          staticClass: "d-print-none",
          attrs: { app: "", dark: "", color: "black", temporary: "" },
          model: {
            value: _vm.navigationVisible,
            callback: function ($$v) {
              _vm.navigationVisible = $$v
            },
            expression: "navigationVisible",
          },
        },
        [
          _c(VListItem, { staticStyle: { height: "56px" } }, [
            _c("img", {
              staticClass: "hidden-sm-and-up mr-1",
              attrs: {
                height: "20",
                src: "/content/img/morecore-logo-2022.svg",
                alt: "MoreCore Logo",
              },
            }),
            _vm._v(" "),
            _c(
              "h3",
              {
                staticClass: "mc-header hidden-sm-and-up",
                staticStyle: {
                  "font-size": "26px !important",
                  "line-height": "35px !important",
                },
              },
              [_vm._v("\n        INSIGHTS\n      ")],
            ),
          ]),
          _vm._v(" "),
          _c(VDivider),
          _vm._v(" "),
          !_vm.authenticated
            ? _c(
                VList,
                { attrs: { nav: "" } },
                [
                  _c(
                    VListItem,
                    { attrs: { to: "/" } },
                    [
                      _c(
                        VListItemIcon,
                        [_c(VIcon, [_vm._v("fas fa-fw fa-sign-in-alt")])],
                        1,
                      ),
                      _vm._v(" "),
                      _c(
                        VListItemContent,
                        [
                          _c(
                            VListItemTitle,
                            [_c("I18nLabel", [_vm._v("navigation.login")])],
                            1,
                          ),
                        ],
                        1,
                      ),
                    ],
                    1,
                  ),
                  _vm._v(" "),
                  _c(VListItem, [_vm._v(" v" + _vm._s(_vm.version))]),
                ],
                1,
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.authenticated
            ? _c(
                VList,
                { attrs: { nav: "" } },
                [
                  _c(
                    VListItem,
                    { attrs: { to: "/" } },
                    [
                      _c(
                        VListItemIcon,
                        [_c(VIcon, [_vm._v("fas fa-fw fa-home")])],
                        1,
                      ),
                      _vm._v(" "),
                      _c(
                        VListItemContent,
                        [
                          _c(
                            VListItemTitle,
                            [_c("I18nLabel", [_vm._v("navigation.dashboard")])],
                            1,
                          ),
                        ],
                        1,
                      ),
                    ],
                    1,
                  ),
                  _vm._v(" "),
                  _vm.hasAnyAuthority(["ROLE_MODERATOR", "ROLE_ADMIN"])
                    ? [
                        _c(
                          VListItem,
                          { attrs: { to: "/publication" } },
                          [
                            _c(
                              VListItemIcon,
                              [
                                _c(VIcon, [
                                  _vm._v("fas fa-fw fa-share-alt-square"),
                                ]),
                              ],
                              1,
                            ),
                            _vm._v(" "),
                            _c(
                              VListItemContent,
                              [
                                _c(
                                  VListItemTitle,
                                  [
                                    _c("I18nLabel", [
                                      _vm._v("navigation.posts"),
                                    ]),
                                  ],
                                  1,
                                ),
                              ],
                              1,
                            ),
                          ],
                          1,
                        ),
                        _vm._v(" "),
                        _c(
                          VListItem,
                          { attrs: { to: "/ads" } },
                          [
                            _c(
                              VListItemIcon,
                              [_c(VIcon, [_vm._v("fas fa-fw fa-ad")])],
                              1,
                            ),
                            _vm._v(" "),
                            _c(
                              VListItemContent,
                              [
                                _c(
                                  VListItemTitle,
                                  [_c("I18nLabel", [_vm._v("navigation.ads")])],
                                  1,
                                ),
                              ],
                              1,
                            ),
                          ],
                          1,
                        ),
                        _vm._v(" "),
                        _c(
                          VListItem,
                          { attrs: { to: "/campaign" } },
                          [
                            _c(
                              VListItemIcon,
                              [
                                _c(VIcon, [
                                  _vm._v("fas fa-fw fa-chart-line"),
                                ]),
                              ],
                              1,
                            ),
                            _vm._v(" "),
                            _c(
                              VListItemContent,
                              [
                                _c(
                                  VListItemTitle,
                                  [
                                    _c("I18nLabel", [
                                      _vm._v("navigation.campaigns"),
                                    ]),
                                  ],
                                  1,
                                ),
                              ],
                              1,
                            ),
                          ],
                          1,
                        ),
                        _vm._v(" "),
                        _c(
                          VListItem,
                          { attrs: { to: "/customer" } },
                          [
                            _c(
                              VListItemIcon,
                              [_c(VIcon, [_vm._v("fas fa-fw fa-user-tie")])],
                              1,
                            ),
                            _vm._v(" "),
                            _c(
                              VListItemContent,
                              [
                                _c(
                                  VListItemTitle,
                                  [
                                    _c("I18nLabel", [
                                      _vm._v("navigation.customers"),
                                    ]),
                                  ],
                                  1,
                                ),
                              ],
                              1,
                            ),
                          ],
                          1,
                        ),
                        _vm._v(" "),
                        _c(
                          VListItem,
                          { attrs: { to: "/reports" } },
                          [
                            _c(
                              VListItemIcon,
                              [
                                _c(VIcon, [
                                  _vm._v("fas fa-fw fa-chart-line"),
                                ]),
                              ],
                              1,
                            ),
                            _vm._v(" "),
                            _c(
                              VListItemContent,
                              [
                                _c(
                                  VListItemTitle,
                                  [
                                    _c("I18nLabel", [
                                      _vm._v("navigation.reports"),
                                    ]),
                                  ],
                                  1,
                                ),
                              ],
                              1,
                            ),
                          ],
                          1,
                        ),
                        _vm._v(" "),
                        _c(
                          VListItem,
                          { attrs: { to: "/eventLog" } },
                          [
                            _c(
                              VListItemIcon,
                              [_c(VIcon, [_vm._v("fas fa-fw fa-list")])],
                              1,
                            ),
                            _vm._v(" "),
                            _c(
                              VListItemContent,
                              [
                                _c(
                                  VListItemTitle,
                                  [
                                    _c("I18nLabel", [
                                      _vm._v("navigation.eventLog"),
                                    ]),
                                  ],
                                  1,
                                ),
                              ],
                              1,
                            ),
                          ],
                          1,
                        ),
                        _vm._v(" "),
                        _c(
                          VListItem,
                          { attrs: { to: "/settings" } },
                          [
                            _c(
                              VListItemIcon,
                              [_c(VIcon, [_vm._v("fas fa-fw fa-cogs")])],
                              1,
                            ),
                            _vm._v(" "),
                            _c(
                              VListItemContent,
                              [
                                _c(
                                  VListItemTitle,
                                  [
                                    _c("I18nLabel", [
                                      _vm._v("navigation.settings"),
                                    ]),
                                  ],
                                  1,
                                ),
                              ],
                              1,
                            ),
                          ],
                          1,
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasAnyAuthority(["ROLE_USER"])
                    ? _c(
                        VListItem,
                        { attrs: { to: "/my-campaigns" } },
                        [
                          _c(
                            VListItemIcon,
                            [_c(VIcon, [_vm._v("fas fa-fw fa-share-alt")])],
                            1,
                          ),
                          _vm._v(" "),
                          _c(
                            VListItemContent,
                            [
                              _c(
                                VListItemTitle,
                                [
                                  _c("I18nLabel", [
                                    _vm._v("navigation.my_campaigns"),
                                  ]),
                                ],
                                1,
                              ),
                            ],
                            1,
                          ),
                        ],
                        1,
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    VListItem,
                    {
                      on: {
                        click: function ($event) {
                          _vm.showReleaseNotes = true
                        },
                      },
                    },
                    [_vm._v("\n        v" + _vm._s(_vm.version) + "\n      ")],
                  ),
                ],
                2,
              )
            : _vm._e(),
          _vm._v(" "),
          _c(VSpacer),
        ],
        1,
      ),
      _vm._v(" "),
      _c(
        VAppBar,
        {
          staticClass: "d-print-none d-flex justify-space-between",
          attrs: { app: "", color: "primary", dark: "" },
        },
        [
          _c(
            "div",
            { staticClass: "flex-third" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "secondary", icon: "", tile: "" },
                  on: {
                    click: function ($event) {
                      _vm.navigationVisible = !_vm.navigationVisible
                    },
                  },
                },
                [_c(VIcon, [_vm._v("fas fa-bars")])],
                1,
              ),
            ],
            1,
          ),
          _vm._v(" "),
          _c(
            VToolbarTitle,
            {
              staticClass:
                "d-flex align-center justify-center flex-third overflow-visible",
            },
            [
              _c("img", {
                staticClass: "flex-shrink-1 mr-2 hidden-xs-only",
                attrs: {
                  height: "25",
                  src: "/content/img/morecore-logo-2022.svg",
                  alt: "MoreCore Logo",
                },
              }),
              _vm._v(" "),
              _c("h3", { staticClass: "mc-header hidden-xs-only" }, [
                _vm._v("INSIGHTS"),
              ]),
            ],
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex align-end flex-third" },
            [
              _c(VSpacer),
              _vm._v(" "),
              !_vm.authenticated
                ? _c(
                    VBtn,
                    {
                      staticClass: "font-weight-bold grey--text",
                      attrs: {
                        text: "",
                        href: "https://www.morecore.de/impressum/",
                      },
                    },
                    [_c("I18nLabel", [_vm._v("home.imprint")])],
                    1,
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.authenticated
                ? _c(
                    VBtn,
                    {
                      staticClass: "font-weight-bold grey--text",
                      attrs: {
                        text: "",
                        href: "https://www.morecore.de/datenschutzerklaerung/",
                      },
                    },
                    [_c("I18nLabel", [_vm._v("home.dataProtection")])],
                    1,
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasAnyAuthority(["ROLE_ADMIN"]) && _vm.authenticated
                ? _c(
                    VMenu,
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              return [
                                _c(
                                  VBtn,
                                  _vm._g(
                                    {
                                      staticClass: "grey--text",
                                      attrs: { text: "" },
                                    },
                                    on,
                                  ),
                                  [
                                    _c(VIcon, { attrs: { left: "" } }, [
                                      _vm._v("fas fa-wrench"),
                                    ]),
                                    _vm._v("\n            Admin\n          "),
                                  ],
                                  1,
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        791846223,
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        VList,
                        { attrs: { dense: "" } },
                        [
                          _c(
                            VListItem,
                            {
                              attrs: {
                                to: "/admin/actions",
                                "active-class": "active",
                              },
                            },
                            [
                              _c(
                                VListItemIcon,
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v("fas fa-wrench"),
                                  ]),
                                ],
                                1,
                              ),
                              _vm._v(" "),
                              _c(
                                VListItemContent,
                                {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("global.menu.admin.actions"),
                                    ),
                                  },
                                },
                                [_vm._v("Actions\n            ")],
                              ),
                            ],
                            1,
                          ),
                          _vm._v(" "),
                          _c(
                            VListItem,
                            {
                              attrs: {
                                to: "/admin/clients",
                                "active-class": "active",
                              },
                            },
                            [
                              _c(
                                VListItemIcon,
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v("fas fa-house-user"),
                                  ]),
                                ],
                                1,
                              ),
                              _vm._v(" "),
                              _c(
                                VListItemContent,
                                {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("global.menu.admin.clients"),
                                    ),
                                  },
                                },
                                [_vm._v("Clients\n            ")],
                              ),
                            ],
                            1,
                          ),
                          _vm._v(" "),
                          _c(
                            VListItem,
                            {
                              attrs: {
                                to: "/admin/metrics",
                                "active-class": "active",
                              },
                            },
                            [
                              _c(
                                VListItemIcon,
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v("fas fa-tachometer-alt"),
                                  ]),
                                ],
                                1,
                              ),
                              _vm._v(" "),
                              _c(
                                VListItemContent,
                                {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("global.menu.admin.metrics"),
                                    ),
                                  },
                                },
                                [_vm._v("Metrics\n            ")],
                              ),
                            ],
                            1,
                          ),
                          _vm._v(" "),
                          _c(
                            VListItem,
                            {
                              attrs: {
                                to: "/admin/health",
                                "active-class": "active",
                              },
                            },
                            [
                              _c(
                                VListItemIcon,
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v("fas fa-heart"),
                                  ]),
                                ],
                                1,
                              ),
                              _vm._v(" "),
                              _c(
                                VListItemContent,
                                {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("global.menu.admin.health"),
                                    ),
                                  },
                                },
                                [_vm._v("Health\n            ")],
                              ),
                            ],
                            1,
                          ),
                          _vm._v(" "),
                          _c(
                            VListItem,
                            {
                              attrs: {
                                to: "/admin/configuration",
                                "active-class": "active",
                              },
                            },
                            [
                              _c(
                                VListItemIcon,
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v("fas fa-cogs"),
                                  ]),
                                ],
                                1,
                              ),
                              _vm._v(" "),
                              _c(
                                VListItemContent,
                                {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("global.menu.admin.configuration"),
                                    ),
                                  },
                                },
                                [_vm._v("Configuration\n            ")],
                              ),
                            ],
                            1,
                          ),
                          _vm._v(" "),
                          _c(
                            VListItem,
                            {
                              attrs: {
                                to: "/admin/logs",
                                "active-class": "active",
                              },
                            },
                            [
                              _c(
                                VListItemIcon,
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v("fas fa-tasks"),
                                  ]),
                                ],
                                1,
                              ),
                              _vm._v(" "),
                              _c(
                                VListItemContent,
                                {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("global.menu.admin.logs"),
                                    ),
                                  },
                                },
                                [_vm._v("Logs\n            ")],
                              ),
                            ],
                            1,
                          ),
                          _vm._v(" "),
                          _vm.openAPIEnabled
                            ? _c(
                                VListItem,
                                {
                                  attrs: {
                                    to: "/admin/docs",
                                    "active-class": "active",
                                  },
                                },
                                [
                                  _c(
                                    VListItemIcon,
                                    [
                                      _c(VIcon, { attrs: { small: "" } }, [
                                        _vm._v("fas fa-book"),
                                      ]),
                                    ],
                                    1,
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    VListItemContent,
                                    {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.$t("global.menu.admin.apidocs"),
                                        ),
                                      },
                                    },
                                    [_vm._v("API\n            ")],
                                  ),
                                ],
                                1,
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            VListItem,
                            { on: { click: _vm.clearCache } },
                            [
                              _c(
                                VListItemIcon,
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v("fa-trash"),
                                  ]),
                                ],
                                1,
                              ),
                              _vm._v(" "),
                              _c(VListItemContent, [
                                _vm._v("Clear L2C cache"),
                              ]),
                            ],
                            1,
                          ),
                        ],
                        1,
                      ),
                    ],
                    1,
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.authenticated
                ? _c(
                    VMenu,
                    {
                      attrs: { bottom: "", "offset-y": "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              return [
                                _c(
                                  VBtn,
                                  _vm._g(
                                    {
                                      staticClass: "grey--text",
                                      attrs: { text: "" },
                                    },
                                    on,
                                  ),
                                  [
                                    _c(VIcon, { attrs: { left: "" } }, [
                                      _vm._v("fas fa-user"),
                                    ]),
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$store.getters.account.firstName,
                                        ) +
                                        "\n            " +
                                        _vm._s(
                                          _vm.$store.getters.account.lastName,
                                        ) +
                                        "\n          ",
                                    ),
                                  ],
                                  1,
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3948899286,
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        VList,
                        { attrs: { dense: "" } },
                        [
                          _c(
                            VListItem,
                            {
                              attrs: {
                                href: "https://www.morecore.de/impressum/",
                                target: "_blank",
                              },
                            },
                            [
                              _c(
                                VListItemIcon,
                                [_c(VIcon, [_vm._v("fas fa-info-circle")])],
                                1,
                              ),
                              _vm._v(" "),
                              _c(
                                VListItemContent,
                                [_c("I18nLabel", [_vm._v("home.imprint")])],
                                1,
                              ),
                            ],
                            1,
                          ),
                          _vm._v(" "),
                          _c(
                            VListItem,
                            {
                              attrs: {
                                href:
                                  "https://www.morecore.de/datenschutzerklaerung/",
                                target: "_blank",
                              },
                            },
                            [
                              _c(
                                VListItemIcon,
                                [_c(VIcon, [_vm._v("fas fa-shield-alt")])],
                                1,
                              ),
                              _vm._v(" "),
                              _c(
                                VListItemContent,
                                [
                                  _c("I18nLabel", [
                                    _vm._v("home.dataProtection"),
                                  ]),
                                ],
                                1,
                              ),
                            ],
                            1,
                          ),
                          _vm._v(" "),
                          _c(
                            VListItem,
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function ($event) {
                                  return _vm.logout()
                                },
                              },
                            },
                            [
                              _c(
                                VListItemIcon,
                                [_c(VIcon, [_vm._v("fas fa-sign-out-alt")])],
                                1,
                              ),
                              _vm._v(" "),
                              _c(
                                VListItemContent,
                                [
                                  _c("I18nLabel", [
                                    _vm._v("global.account.logout"),
                                  ]),
                                ],
                                1,
                              ),
                            ],
                            1,
                          ),
                        ],
                        1,
                      ),
                    ],
                    1,
                  )
                : _vm._e(),
            ],
            1,
          ),
        ],
        1,
      ),
      _vm._v(" "),
      _c(
        VDialog,
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.showReleaseNotes,
            callback: function ($$v) {
              _vm.showReleaseNotes = $$v
            },
            expression: "showReleaseNotes",
          },
        },
        [_c("ReleaseNotes")],
        1,
      ),
    ],
    1,
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }